// src/config.js
// Load environment variables from .env files (Vite automatically loads them with VITE_ prefix)
const isDev = import.meta.env.DEV;

export default {
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL || (isDev ? "http://localhost:8101/api/v1" : "https://ctbbb.surdataconsultores.cl/api/v1"),
  APP_AUTH_URL: import.meta.env.VITE_APP_AUTH_URL || (isDev ? "http://localhost:8100/api/v1" : "https://auth.surdataconsultores.cl/api/v1"),
  APP_ID: parseInt(import.meta.env.VITE_APP_ID || "4", 10)
};